import { Controller, Post, Body, Req } from '@nestjs/common';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ApiTags } from '@nestjs/swagger';
import { EducationResponseModel, AllEducationResponseModel } from '@gtpl/shared-models/hrms';
import { EducationDTO } from './dto/education.dto';
import { EducationsService } from './education.service';
import { EducationIdRequest } from './dto/education.request';


@ApiTags('education')
@Controller('education')
export class EducationController {

    constructor(
        private service: EducationsService,
        private applicationExceptionHandler: ApplicationExceptionHandler
    ){}

    @Post('/createEducation')
    async createEducation(@Body() DTO: EducationDTO, isUpdate: boolean = false): Promise<EducationResponseModel>{
        try{
            return await this.service.createEducation(DTO, false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(EducationResponseModel, error);
        }
    }

    @Post('/updateEducation')
    async updateEducation(@Body() DTO: EducationDTO, isUpdate: boolean = false): Promise<EducationResponseModel>{
        try{
            return await this.service.createEducation(DTO, true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(EducationResponseModel, error);
        }
    }

    @Post('/getAllEducations')
    async getAllEducations(): Promise<AllEducationResponseModel>{
        try{
            return await this.service.getAllEducations();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllEducationResponseModel, error);
        }
    }

    @Post('/getAllActiveEducations')
    async getAllActiveEducations(): Promise<AllEducationResponseModel>{
        try{
            return await this.service.getAllActiveEducations();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllEducationResponseModel, error);
        }
    }

    @Post('/activateOrDeactivate')
    async activateOrDeactivate(@Body() req: EducationIdRequest): Promise<EducationResponseModel>{
        try{
            return await this.service.activateOrDeactivateEducation(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(EducationResponseModel, error);
        }
    }

    @Post('/getEducationDetailsById')
    async getEducationDetailsById(@Body() req: EducationIdRequest): Promise<EducationResponseModel>{
        try{
            return await this.service.getEducationById(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(EducationResponseModel, error);
        }
    }
}
